// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".repurchase-tit-coin {\n  width: 0.74667rem;\n  height: 0.74667rem;\n  margin: 0 0.18667rem;\n}", ""]);
// Exports
module.exports = exports;
